import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { getInstitutionStatus } from '../../api/admin/institution-verification';
import { useAppDispatch } from '../../store';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const InstitutionPrivateRoute = ({ children }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        const getStatus = async () => {
            try {
                const status = await getInstitutionStatus();
                if (status !== 'approved') {
                    navigate(APP_ROUTES.institutionVerification, { replace: true });
                }
            }
            catch (error) {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
            }
        };
        getStatus();
    }, []);
    return children;
};
export default InstitutionPrivateRoute;
